import React, { useState, useContext, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import styled from 'styled-components';
import './Filter.css';
//import FilterIcon from '#public/Images/FilterIcon.png';
import AuthContext from '../../context/AuthContext';
import { useFilters } from "../../context/JWFilterContext";
import SortingFilter from './SortingFilter';
import NumRangeFilter from './NumRangeFilter';
import CaratRangeFilter from './CaratRangeFilter';
import GoldWtRangeFilter from './GoldWtRangeFilter';
import { GetJewelleryParameter } from '../../api/ParameterService';
import { useCount } from "../../context/CountContext";
import { useAuth } from "../../context/AuthContext";
import CustomerSelection from "../../components/Common/CustomerSelection";
import { Link } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";

const useDebouncedCallback = (callback, delay = 1000) => {
    const timeoutRef = useRef(null);

    const debouncedFn = (...args) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    };

    useEffect(() => {
        return () => clearTimeout(timeoutRef.current);
    }, []);

    return debouncedFn;
};

const getParam = (params, key) =>
    params.get(key) ||
    params.get(key.toLowerCase()) ||
    params.get(key.toUpperCase()) ||
    "";

const Filter = ({ productType, setProductType, setSelectedSortValue, loadedCount, totalCount }) => {
    const { cartCount, enquiryCount, wishlistCount, fetchWishlistCount, fetchStyleCartCount } = useCount();
    const { user } = useAuth();
    const {
        filters,
        setRangeFilter,
        toggleMultiSelect,
        toggleSelectAll,
        removeSingleFilter,
        setSearch,
        setFilter,
        updateFilters,
        clearAllFilters
    } = useFilters();

    const [Type, setType] = useState('All');
    const [hideMenu, sethideMenu] = useState(false);
    const ledgerId = user?.LEDGER_ID;
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const [jw_JWFilterParameters, setJWFilterParameters] = useState([]);
    const [jwStyleData, setJWStyleData] = useState([]);
    const [jwSubCategoryData, setJWSubCategoryData] = useState([]);
    const [jwMetalToneData, setJWMetalToneData] = useState([]);
    const [jwGoldQualityData, setJWGoldQualityData] = useState([]);
    const [jwProductSizeData, setJWProductSizeData] = useState([]);
    const [jwSortData, setJWSortData] = useState([]);
    const [visibleFilters, setVisibleFilters] = useState([]);
    const [isParamsLoading, setIsParamsLoading] = useState(true);
    //#endregion VARIABLE DECLARATIONS

    //#region HANDLE FILTER MODAL OPEN/CLOSE

    const handleFilter = (type) => {
        if (Type === type) {
            sethideMenu(false);
            setType('All');
        } else {
            setType(type);
            sethideMenu(true);
        }
    }

    //#endregion HANDLE FILTER MODAL OPEN/CLOSE

    const removeFilterTag = (name) => {
        if (filters.styleNames.includes(name)) removeSingleFilter("styleNames", name);
        else if (filters.subCategoryNames.includes(name)) removeSingleFilter("subCategoryNames", name);
        else if (filters.metalToneNames.includes(name)) removeSingleFilter("metalToneNames", name);
        else if (filters.goldQualityNames.includes(name)) removeSingleFilter("goldQualityNames", name);
        else if (filters.itemSizeNames.includes(name)) removeSingleFilter("itemSizeNames", name);
        else if (filters.collectionNames.includes(name)) removeSingleFilter("collectionNames", name);
    };

    // #region FETCH ALL PARAMETERS FOR JEWELLERY
    const getByParaType = (data, type, sortBy = "Para_ID") => data
        .filter(item => (item.ParaType || item.PARATYPE)?.toUpperCase() === type)
        .sort((a, b) => {
            const aVal = a[sortBy] || a[sortBy.toUpperCase()] || 0;
            const bVal = b[sortBy] || b[sortBy.toUpperCase()] || 0;
            return aVal - bVal;
        });

    useEffect(() => {
        if (user?.SelectedCustomer_ID) {
            fetchWishlistCount(user.SelectedCustomer_ID);
            fetchStyleCartCount(user.SelectedCustomer_ID);
        }
    }, [user?.SelectedCustomer_ID]);

    const fetchJewelleryParameters = async () => {
        try {
            const filterRes = await GetJewelleryParameter({
                Paratype: "STYLE_MENU,PRODUCTCATEGORY,PRODUCTSUBCATEGORY,GOLDQUALITY,METALTONE,PRODUCTSIZE,SORT",
            });

            const filterMenu = filterRes?.JewelleryMenu || filterRes?.ROW || [];

            const styleMenu = getByParaType(filterMenu, "STYLE_MENU");
            const productCategory = getByParaType(filterMenu, "PRODUCTCATEGORY") || getByParaType(filterMenu, "CATEGORY") || getByParaType(filterMenu, "STYLE");
            const productSubCategory = getByParaType(filterMenu, "PRODUCTSUBCATEGORY") || getByParaType(filterMenu, "SUBCATEGORY");
            const goldQuality = getByParaType(filterMenu, "GOLDQUALITY");
            const metalTone = getByParaType(filterMenu, "METALTONE");
            const productSize = getByParaType(filterMenu, "PRODUCTSIZE");
            const sortOptions = getByParaType(filterMenu, "SORT", "SequenceNo")
                .map(item => ({
                    label: item.ParaName || item.PARANAME,
                    value: item.ParaCode || item.PARACODE || item.PARANAME
                }));

            setJWFilterParameters(styleMenu);
            setJWStyleData(productCategory);
            setJWSubCategoryData(productSubCategory);
            setJWMetalToneData(metalTone);
            setJWGoldQualityData(goldQuality);
            setJWProductSizeData(productSize);
            setJWSortData(sortOptions);
        } catch (error) {
            console.error("Error fetching jewellery parameters:", error);
        } finally {
            setIsParamsLoading(false);
        }
    };

    useEffect(() => {
        if (!jw_JWFilterParameters?.length) return;

        const allowedCodes = jw_JWFilterParameters.map(item => (item.ParaCode || item.PARACODE)?.toUpperCase());
        const allFilters = [
            { paracode: "STYLE", label: "Style", code: "style" },
            { paracode: "CATEGORY", label: "Category", code: "category" },
            { paracode: "METALTONE", label: "Metal Tone", code: "metalTone" },
            { paracode: "GOLDQUALITY", label: "Gold Quality", code: "goldQuality" },
            { paracode: "PRICE", label: "Price", code: "price" },
            { paracode: "CARAT", label: "Carat", code: "carat" },
            { paracode: "GOLDWT", label: "Gold Weight", code: "goldwt" },
            { paracode: "ITEMSIZE", label: "Item Size", code: "itemSize" },
            { paracode: "SEARCH", label: "Ring Style", code: "search" }
        ];

        // Filter allFilters based on allowedCodes from API response
        const filtered = allFilters.filter(f =>
            allowedCodes.includes(f.paracode) ||
            allowedCodes.includes(`BY ${f.label.toUpperCase()}`)
        );
        setVisibleFilters(filtered);
    }, [jw_JWFilterParameters]);

    useEffect(() => {
        fetchJewelleryParameters();
    }, [ledgerId]);

    //const callDiamondAPI = async (selectedDiamondIds) => {
    //    const diamondIDs = selectedDiamondIds.length === 0 ? "" : selectedDiamondIds.join(",");

    //    const requestParams = {
    //        DiamondType: diamondIDs
    //    };
    //    try {

    //        const response = await getDiamondTypeClarity(requestParams);
    //        const data = response;

    //        if (data && data.ROW) {
    //            setJWClarity(data.ROW);
    //        } else {
    //            setJWClarity([]);
    //        }

    //    } catch (error) {
    //        console.error("Error fetching diamond clarity:", error);
    //    }
    //};

    // #endregion FETCH ALL PARAMETERS FOR JEWELLERY

    const updateURLFromFilters = (updatedFilters) => {
        const params = new URLSearchParams(location.search);

        updatedFilters.styleNames?.length
            ? params.set("productCategoryName", updatedFilters.styleNames[0])
            : params.delete("productCategoryName");

        updatedFilters.subCategoryNames?.length
            ? params.set("productSubCategoryName", updatedFilters.subCategoryNames[0])
            : params.delete("productSubCategoryName");

        updatedFilters.searchText
            ? params.set("searchtype", updatedFilters.searchText)
            : params.delete("searchtype");

        updatedFilters.collectionNames?.length
            ? params.set("collectionName", updatedFilters.collectionNames[0])
            : params.delete("collectionName");

        navigate(
            {
                pathname: location.pathname,
                search: params.toString() ? `?${params}` : ""
            },
            { replace: true }
        );
    };

    useEffect(() => {
        if (!jwStyleData.length) return;

        const params = new URLSearchParams(location.search);
        if (!params.toString()) return;

        const category = getParam(params, "productCategoryName");
        const subCategory = getParam(params, "productSubCategoryName");
        const collection = getParam(params, "collectionName");
        const search = getParam(params, "searchtype");

        const updatedFilters = {};

        if (category) {
            updatedFilters.styleNames = [
                decodeURIComponent(category).toLowerCase()
            ];
        }

        if (subCategory) {
            updatedFilters.subCategoryNames = [
                decodeURIComponent(subCategory).toLowerCase()
            ];
        }

        if (collection) {
            updatedFilters.collectionNames = [
                decodeURIComponent(collection).toLowerCase()
            ];
        }

        if (search) {
            setSearch(decodeURIComponent(search));
        }

        Object.entries(updatedFilters).forEach(([key, value]) => {
            setFilter(key, value);
        });

    }, [jwStyleData, location]);

    const hasActiveFilters =
        filters.styleNames.length > 0 ||
        filters.subCategoryNames.length > 0 ||
        filters.metalToneNames.length > 0 ||
        filters.goldQualityNames.length > 0 ||
        filters.itemSizeNames.length > 0 ||
        filters.collectionNames.length > 0 ||
        !!filters.searchText ||
        !(filters.priceRange[0] === 0 && filters.priceRange[1] === 1000000) ||
        !(filters.caratRange[0] === 0 && filters.caratRange[1] === 100) ||
        !(filters.goldWtRange[0] === 0 && filters.goldWtRange[1] === 250);

    return (
        <>
            <div className="vault-header-card">
                <div className="vault-header-row">
                    <div className="vault-title">
                        <h2>Style Inventory</h2>
                        <span> ({loadedCount || 0} / {totalCount || 0} items) </span>
                    </div>

                    <div className="vaultaccess-action-group">
                        <button
                            type="button"
                            className="btn-primary"
                            onClick={() => {
                                handleFilter("All");
                                sethideMenu(false);
                            }}
                        >
                            <span>Search</span>
                        </button>
                        <div className="sort-wrapper">
                            <Dropdown
                                value={filters.sort}
                                options={jwSortData}
                                onChange={(e) => {
                                    const updated = { ...filters, sort: e.value };
                                    updateFilters(updated);
                                    setRangeFilter("sort", e.value);
                                    if (setSelectedSortValue) setSelectedSortValue(e.value);
                                }}
                                placeholder="Sort By"
                                className="vault-sort-dropdown"
                                appendTo="self"
                            />
                        </div>
                        <div className="customer-wrapper">
                            <CustomerSelection />
                        </div>
                        <div className="header-actions">
                            <div className="action-icon-wrapper">
                                <Link to="/Wishlist" className="action-circle-container enquiry" title="Wishlist">
                                    <i className="pi pi-heart action-icon"></i>
                                    {wishlistCount > 0 && (
                                        <span className="action-badge enquiry-bg">{wishlistCount}</span>
                                    )}
                                </Link>
                            </div>
                            <div className="action-icon-wrapper">
                                <Link to="/StyleCart" className="action-circle-container cart" title="Style Cart">
                                    <i className="pi pi-shopping-cart action-icon"></i>
                                    {cartCount > 0 && (
                                        <span className="action-badge cart-bg">{cartCount}</span>
                                    )}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="vault-filter-card">
                    <div className="vaultaccess-filters stock-vault-filter">
                        <div className="filters-header">
                            <div className="filters-left">
                                <div className="filter-pill" onClick={() => handleFilter('style')}>
                                    <i className="pi pi-sliders-h"></i>
                                    <span>All Filter</span>
                                    <i className="pi pi-chevron-down" />
                                </div>

                                {isParamsLoading ? (
                                    [...Array(6)].map((_, i) => (
                                        <div key={i} className="filter-pill skeleton-pill">
                                            <div className="skeleton-pulse" style={{ width: '60px', height: '14px', borderRadius: '4px' }}></div>
                                        </div>
                                    ))
                                ) : (
                                    visibleFilters.map(({ code, label }) => (
                                        <div
                                            key={code}
                                            className={`filter-pill ${Type === code ? 'active' : ''}`}
                                            onClick={() => handleFilter(code)}
                                        >
                                            <span>{label}</span>
                                            <i className="pi pi-chevron-down" />
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>

                    {hideMenu && (
                        <div className="filter_dropdown_wrapper">
                            <div className="filterval">
                                {{
                                    style: <ByStyle jwStyleData={jwStyleData} />,
                                    category: <BySubStyle jwSubCategoryData={jwSubCategoryData} />,
                                    metalTone: <ByMetalTone jwMetalToneData={jwMetalToneData} />,
                                    goldQuality: <ByGoldQuality jwGoldQualityData={jwGoldQualityData} />,
                                    price: <PriceRange />,
                                    carat: <CaratRange />,
                                    goldwt: <GoldWtRange />,
                                    itemSize: <ByItemSize jwProductSizeData={jwProductSizeData} />,
                                    search: <ByRingStyle />
                                }[Type] || null}
                            </div>
                        </div>
                    )}
                </div>

                {hasActiveFilters && (
                    <div className="selected-filters">
                        <button
                            className="btnClearAllFilter"
                            onClick={() => {
                                clearAllFilters();
                                navigate({ pathname: location.pathname, search: "" }, { replace: true });
                            }}
                        >
                            Clear All ×
                        </button>
                        <div className="selected-tags-container">
                            {[...filters.styleNames, ...filters.subCategoryNames, ...filters.metalToneNames, ...filters.goldQualityNames, ...filters.itemSizeNames, ...filters.collectionNames].map((name, idx) => (
                                <span key={idx} className="selected-tag">
                                    {name} <span className="ms-1 cursor-pointer" onClick={() => removeFilterTag(name)}>×</span>
                                </span>
                            ))}
                            {filters.searchText && (
                                <span className="selected-tag">
                                    {filters.searchText} <span className="ms-1 cursor-pointer" onClick={() => setSearch("")}>×</span>
                                </span>
                            )}
                            {!(filters.priceRange[0] === 0 && filters.priceRange[1] === 1000000) && (
                                <span className="selected-tag">
                                    ₹{filters.priceRange[0]?.toLocaleString()} - ₹{filters.priceRange[1]?.toLocaleString()} <span className="ms-1 cursor-pointer" onClick={() => setRangeFilter("priceRange", [0, 1000000])}>×</span>
                                </span>
                            )}
                            {!(filters.caratRange[0] === 0 && filters.caratRange[1] === 100) && (
                                <span className="selected-tag">
                                    {filters.caratRange[0]} CT - {filters.caratRange[1]} CT <span className="ms-1 cursor-pointer" onClick={() => setRangeFilter("caratRange", [0, 100])}>×</span>
                                </span>
                            )}
                            {!(filters.goldWtRange[0] === 0 && filters.goldWtRange[1] === 250) && (
                                <span className="selected-tag">
                                    {filters.goldWtRange[0]} GM - {filters.goldWtRange[1]} GM <span className="ms-1 cursor-pointer" onClick={() => setRangeFilter("goldWtRange", [0, 250])}>×</span>
                                </span>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Filter;

// #region FOR FILTERS

// #region BY STYLE (PRODUCT CATEGORY) FILTER

const ByStyle = ({ jwStyleData = [] }) => {
    const { filters, toggleMultiSelect, toggleSelectAll } = useFilters();
    const allNames = jwStyleData.map(s => s.ParaName.toLowerCase());
    const selected = filters.styleNames;
    const isAllSelected = allNames.length > 0 && selected.length === allNames.length;

    if (!jwStyleData.length) return null;

    return (
        <div className="filter-grid-inline">
            <div className="form-check filter-option select-all-option">
                <input
                    id="style-all"
                    type="checkbox"
                    className="form-check-input"
                    checked={isAllSelected}
                    onChange={() => toggleSelectAll("styleNames", allNames)}
                />
                <label htmlFor="style-all" className="form-check-label">
                    Select All
                </label>
            </div>

            {jwStyleData.map(s => {
                const value = s.ParaName.toLowerCase();
                const id = `style-${s.Para_ID}`;
                const isActive = selected.includes(value);

                return (
                    <div key={s.Para_ID} className={`form-check filter-option ${isActive ? 'active' : ''}`}>
                        <input
                            id={id}
                            type="checkbox"
                            className="form-check-input"
                            checked={isActive}
                            onChange={() => toggleMultiSelect("styleNames", value)}
                        />
                        <label htmlFor={id} className="form-check-label">
                            {s.ParaName}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

// #endregion BY STYLE (PRODUCT CATEGORY) FILTER

// #region BY SUB STYLE (PRODUCT SUBCATEGORY) FILTER

const BySubStyle = ({ jwSubCategoryData = [] }) => {
    const { filters, toggleMultiSelect, toggleSelectAll } = useFilters();
    const allNames = jwSubCategoryData.map(s => s.ParaName.toLowerCase());
    const selected = filters.subCategoryNames;
    const isAllSelected = allNames.length > 0 && selected.length === allNames.length;

    if (!jwSubCategoryData.length) return null;

    return (
        <div className="filter-grid-inline">
            <div className="form-check filter-option select-all-option">
                <input
                    id="substyle-all"
                    type="checkbox"
                    className="form-check-input"
                    checked={isAllSelected}
                    onChange={() => toggleSelectAll("subCategoryNames", allNames)}
                />
                <label htmlFor="substyle-all" className="form-check-label">
                    Select All
                </label>
            </div>

            {jwSubCategoryData.map(sub => {
                const value = sub.ParaName.toLowerCase();
                const id = `substyle-${sub.Para_ID}`;
                const isActive = selected.includes(value);

                return (
                    <div key={sub.Para_ID} className={`form-check filter-option ${isActive ? 'active' : ''}`}>
                        <input
                            id={id}
                            type="checkbox"
                            className="form-check-input"
                            checked={isActive}
                            onChange={() => toggleMultiSelect("subCategoryNames", value)}
                        />
                        <label htmlFor={id} className="form-check-label">
                            {sub.ParaName}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

// #endregion BY SUB STYLE (PRODUCT SUBCATEGORY) FILTER

// #region BY METAL TONE

const ByMetalTone = ({ jwMetalToneData = [] }) => {
    const { filters, toggleMultiSelect, toggleSelectAll } = useFilters();
    const allNames = jwMetalToneData.map(t => t.ParaName);
    const selected = filters.metalToneNames;
    const isAllSelected = allNames.length > 0 && selected.length === allNames.length;

    if (!jwMetalToneData.length) return null;

    return (
        <div className="filter-grid-inline">
            <div className="form-check filter-option select-all-option">
                <input
                    id="metal-all"
                    type="checkbox"
                    className="form-check-input"
                    checked={isAllSelected}
                    onChange={() => toggleSelectAll("metalToneNames", allNames)}
                />
                <label htmlFor="metal-all" className="form-check-label">
                    Select All
                </label>
            </div>

            {jwMetalToneData.map(tone => {
                const id = `metal-${tone.Para_ID}`;
                const isActive = selected.includes(tone.ParaName);

                return (
                    <div key={tone.Para_ID} className={`form-check filter-option ${isActive ? 'active' : ''}`}>
                        <input
                            id={id}
                            type="checkbox"
                            className="form-check-input"
                            checked={isActive}
                            onChange={() => toggleMultiSelect("metalToneNames", tone.ParaName)}
                        />
                        <label htmlFor={id} className="form-check-label">
                            {tone.ParaName}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

// #endregion BY METAL TONE

// #region BY GOLD QUALITY

const ByGoldQuality = ({ jwGoldQualityData = [] }) => {
    const { filters, toggleMultiSelect, toggleSelectAll } = useFilters();
    const allNames = jwGoldQualityData.map(q => q.ParaName);
    const selected = filters.goldQualityNames;
    const isAllSelected = allNames.length > 0 && selected.length === allNames.length;

    if (!jwGoldQualityData.length) return null;

    return (
        <div className="filter-grid-inline">
            <div className="form-check filter-option select-all-option">
                <input
                    id="gold-all"
                    type="checkbox"
                    className="form-check-input"
                    checked={isAllSelected}
                    onChange={() => toggleSelectAll("goldQualityNames", allNames)}
                />
                <label htmlFor="gold-all" className="form-check-label">
                    Select All
                </label>
            </div>

            {jwGoldQualityData.map(q => {
                const id = `gold-${q.Para_ID}`;
                const isActive = selected.includes(q.ParaName);

                return (
                    <div key={q.Para_ID} className={`form-check filter-option ${isActive ? 'active' : ''}`}>
                        <input
                            id={id}
                            type="checkbox"
                            className="form-check-input"
                            checked={isActive}
                            onChange={() => toggleMultiSelect("goldQualityNames", q.ParaName)}
                        />
                        <label htmlFor={id} className="form-check-label">
                            {q.ParaName}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

// #endregion BY GOLD QUALITY

// #region BY ITEM SIZE

const ByItemSize = ({ jwProductSizeData = [] }) => {
    const { filters, toggleMultiSelect, toggleSelectAll } = useFilters();
    const allNames = jwProductSizeData.map(s => s.ParaName);
    const selected = filters.itemSizeNames;
    const isAllSelected = allNames.length > 0 && selected.length === allNames.length;

    if (!jwProductSizeData.length) return null;

    return (
        <div className="filter-grid-inline">
            <div className="form-check filter-option select-all-option">
                <input
                    id="size-all"
                    type="checkbox"
                    className="form-check-input"
                    checked={isAllSelected}
                    onChange={() => toggleSelectAll("itemSizeNames", allNames)}
                />
                <label htmlFor="size-all" className="form-check-label">
                    Select All
                </label>
            </div>

            {jwProductSizeData.map(s => {
                const id = `size-${s.Para_ID}`;
                const isActive = selected.includes(s.ParaName);

                return (
                    <div key={s.Para_ID} className={`form-check filter-option ${isActive ? 'active' : ''}`}>
                        <input
                            id={id}
                            type="checkbox"
                            className="form-check-input"
                            checked={isActive}
                            onChange={() => toggleMultiSelect("itemSizeNames", s.ParaName)}
                        />
                        <label htmlFor={id} className="form-check-label">
                            {s.ParaName}
                        </label>
                    </div>
                );
            })}
        </div>
    );
};

// #endregion BY ITEM SIZE

// #region By PRICERANGE FILTER

const PriceRange = () => {
    const { filters, setRangeFilter } = useFilters();
    const [inputRange, setInputRange] = useState([
        String(filters.priceRange[0]),
        String(filters.priceRange[1]),
    ]);

    const [sliderRange, setSliderRange] = useState(filters.priceRange);
    const isTypingRef = useRef(false);

    useEffect(() => {
        if (!isTypingRef.current) {
            setInputRange([
                String(filters.priceRange[0]),
                String(filters.priceRange[1]),
            ]);
            setSliderRange(filters.priceRange);
        }
    }, [filters.priceRange]);

    const debouncedApply = useDebouncedCallback((minInput, maxInput) => {
        isTypingRef.current = false;

        const prevMin = filters.priceRange?.[0] ?? 0;
        const prevMax = filters.priceRange?.[1] ?? 1000000;

        const min = Number.isFinite(Number(minInput))
            ? Number(minInput)
            : prevMin;

        const max = Number.isFinite(Number(maxInput))
            ? Number(maxInput)
            : prevMax;

        setSliderRange([min, max]);
        setRangeFilter("priceRange", [min, max]);
    }, 600);

    return (
        <div className="price-slider-wrapper">
            <div className="d-flex align-items-start gap-3">
                <div className="col-12 col-lg-4 col-md-4 col-sm-4">
                    <div className="range-container">
                        <NumRangeFilter
                            min={0}
                            max={1000000}
                            step={1}
                            values={sliderRange}
                            onChange={(range) => {
                                isTypingRef.current = false;
                                setSliderRange(range);
                                setInputRange([
                                    String(range[0]),
                                    String(range[1]),
                                ]);
                                setRangeFilter("priceRange", range);
                            }}
                            hideText={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                            <span className="text-muted font-small">₹ {Number(sliderRange[0]).toLocaleString()}</span>
                            <span className="text-muted font-small">₹ {Number(sliderRange[1]).toLocaleString()}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-4 col-md-8 col-sm-4">
                    <div className="row g-2">
                        <div className="col-4">
                            <label className="form-label">From (₹)</label>
                            <input
                                type="text"
                                className="form-control"
                                inputMode="numeric"
                                value={inputRange[0]}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (!/^\d*$/.test(val)) return;
                                    isTypingRef.current = true;
                                    setInputRange([val, inputRange[1]]);
                                    debouncedApply(val, inputRange[1]);
                                }}
                            />
                        </div>
                        <div className="col-4">
                            <label className="form-label">To (₹)</label>
                            <input
                                type="text"
                                className="form-control"
                                inputMode="numeric"
                                value={inputRange[1]}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (!/^\d*$/.test(val)) return;
                                    isTypingRef.current = true;
                                    setInputRange([inputRange[0], val]);
                                    debouncedApply(inputRange[0], val);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// #endregion By PRICERANGE FILTER

// #region By CARAT RANGE FILTER

const CaratRange = () => {
    const { filters, setRangeFilter } = useFilters();
    const [inputRange, setInputRange] = useState([
        String(filters.caratRange[0]),
        String(filters.caratRange[1]),
    ]);

    const [sliderRange, setSliderRange] = useState(filters.caratRange);
    const isTypingRef = useRef(false);
    useEffect(() => {
        if (!isTypingRef.current) {
            setInputRange([
                String(filters.caratRange[0]),
                String(filters.caratRange[1]),
            ]);
            setSliderRange(filters.caratRange);
        }
    }, [filters.caratRange]);

    const debouncedApply = useDebouncedCallback((minInput, maxInput) => {
        isTypingRef.current = false;

        const prevMin = filters.caratRange?.[0] ?? 0;
        const prevMax = filters.caratRange?.[1] ?? 100;

        const min = Number.isFinite(Number(minInput)) ? Number(minInput) : prevMin;
        const max = Number.isFinite(Number(maxInput)) ? Number(maxInput) : prevMax;

        setSliderRange([min, max]);
        setRangeFilter("caratRange", [min, max]);
    }, 600);

    return (
        <div className="price-slider-wrapper">
            <div className="d-flex align-items-start gap-3">
                <div className="col-12 col-lg-4 col-md-4 col-sm-4">
                    <div className="range-container">
                        <CaratRangeFilter
                            min={0}
                            max={100}
                            step={1}
                            values={sliderRange}
                            onChange={(range) => {
                                isTypingRef.current = false;
                                setSliderRange(range);
                                setInputRange([
                                    String(range[0]),
                                    String(range[1]),
                                ]);
                                setRangeFilter("caratRange", range);
                            }}
                            hideText={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                            <span className="text-muted font-small">{sliderRange[0]} CT</span>
                            <span className="text-muted font-small">{sliderRange[1]} CT</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-4 col-md-8 col-sm-4">
                    <div className="row g-2">
                        <div className="col-4">
                            <label className="form-label">From (CT)</label>
                            <input
                                type="text"
                                className="form-control"
                                inputMode="numeric"
                                value={inputRange[0]}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (!/^\d*$/.test(val)) return;
                                    isTypingRef.current = true;
                                    setInputRange([val, inputRange[1]]);
                                    debouncedApply(val, inputRange[1]);
                                }}
                            />
                        </div>
                        <div className="col-4">
                            <label className="form-label">To (CT)</label>
                            <input
                                type="text"
                                className="form-control"
                                inputMode="numeric"
                                value={inputRange[1]}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (!/^\d*$/.test(val)) return;
                                    isTypingRef.current = true;
                                    setInputRange([inputRange[0], val]);
                                    debouncedApply(inputRange[0], val);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// #endregion By CARAT RANGE FILTER

// #region By GOLD WEIGHT RANGE FILTER

const GoldWtRange = () => {
    const { filters, setRangeFilter } = useFilters();

    const [inputRange, setInputRange] = useState([
        String(filters.goldWtRange[0]),
        String(filters.goldWtRange[1]),
    ]);

    const [sliderRange, setSliderRange] = useState(filters.goldWtRange);
    const isTypingRef = useRef(false);

    useEffect(() => {
        if (!isTypingRef.current) {
            setInputRange([
                String(filters.goldWtRange[0]),
                String(filters.goldWtRange[1]),
            ]);
            setSliderRange(filters.goldWtRange);
        }
    }, [filters.goldWtRange]);

    const debouncedApply = useDebouncedCallback((minInput, maxInput) => {
        isTypingRef.current = false;

        const prevMin = filters.goldWtRange?.[0] ?? 0;
        const prevMax = filters.goldWtRange?.[1] ?? 250;

        const min = Number.isFinite(Number(minInput)) ? Number(minInput) : prevMin;
        const max = Number.isFinite(Number(maxInput)) ? Number(maxInput) : prevMax;

        setSliderRange([min, max]);
        setRangeFilter("goldWtRange", [min, max]);
    }, 600);

    return (
        <div className="price-slider-wrapper">
            <div className="d-flex align-items-start gap-3">
                <div className="col-12 col-lg-4 col-md-4 col-sm-4">
                    <div className="range-container">
                        <GoldWtRangeFilter
                            min={0}
                            max={250}
                            step={1}
                            values={sliderRange}
                            onChange={(range) => {
                                isTypingRef.current = false;
                                setSliderRange(range);
                                setInputRange([
                                    String(range[0]),
                                    String(range[1]),
                                ]);
                                setRangeFilter("goldWtRange", range);
                            }}
                            hideText={true}
                        />
                        <div className="d-flex justify-content-between mt-2">
                            <span className="text-muted font-small">{sliderRange[0]} GM</span>
                            <span className="text-muted font-small">{sliderRange[1]} GM</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-4 col-md-8 col-sm-4">
                    <div className="row g-2">
                        <div className="col-4">
                            <label className="form-label">From (GM)</label>
                            <input
                                type="text"
                                className="form-control"
                                inputMode="numeric"
                                value={inputRange[0]}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (!/^\d*$/.test(val)) return;
                                    isTypingRef.current = true;
                                    setInputRange([val, inputRange[1]]);
                                    debouncedApply(val, inputRange[1]);
                                }}
                            />
                        </div>
                        <div className="col-4">
                            <label className="form-label">To (GM)</label>
                            <input
                                type="text"
                                className="form-control"
                                inputMode="numeric"
                                value={inputRange[1]}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (!/^\d*$/.test(val)) return;
                                    isTypingRef.current = true;
                                    setInputRange([inputRange[0], val]);
                                    debouncedApply(inputRange[0], val);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// #endregion By GOLD WEIGHT RANGE FILTER

// #region By RING STYLE TEXT SEARCH

const ByRingStyle = () => {
    const { filters, setSearch } = useFilters();

    return (
        <div className="pricerange">
            <div className="jew_pricerange">
                <div className="diamond_price_filter">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search Ring Style..."
                        value={filters.searchText}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSearch(value);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

// #endregion By RING STYLE TEXT SEARCH

// #endregion FOR FILTERS

export { ByStyle, BySubStyle, ByMetalTone, ByGoldQuality, PriceRange, CaratRange, GoldWtRange, ByItemSize, ByRingStyle };
